import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ORDERDETAILSPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderDetailsPageDescriptor: _generatedOrderDetailsPageDescriptor,
  orderDetailsPageBlocDefinition,
  orderDetailsPageDashboardLayout,
  orderDetailsPageConfig,
  orderDetailsPageResolveConfig,
  orderDetailsPageProperties,
} = doodBlockConfig(
  {
    name: "Order details page",
    internal_name: "Order details page",
    url: "orders/:orderId/details",
    defaultParent: [/^Main Layout$/i],
    componentType: 'OrderDetailsPageComponent',
    category: 'page',
    description: "Order details page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.order-details-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.order-details-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function orderDetailsPageDescriptor(): IBlockDescriptor;
export function orderDetailsPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderDetailsPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderDetailsPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrderDetailsPageDescriptor, orderDetailsPageProperties, fieldOrder);
}

export {
  orderDetailsPageBlocDefinition,
  orderDetailsPageDashboardLayout,
  orderDetailsPageProperties,
  orderDetailsPageConfig,
  orderDetailsPageResolveConfig,
};

export type OrderDetailsPageConfig = typeof orderDetailsPageConfig;
